/** Mirrors the service's `SEARCH_PERSONAS_MAX`: one persona per search, whose search defaults fill the filters. */
export const SEARCH_PERSONAS_MAX = 1;
/** Mirrors the service's `LOOKALIKE_SEEDS_MAX`. */
export const LOOKALIKE_SEEDS_MAX = 12;
/** About what one handle's suggestion walk yields once its matches are checked (staging runs: 10-20). */
export const SINGLE_SEED_TYPICAL_MAX = 20;
export const MULTI_SEED_MIN = 2;
export const HANDLE_PATTERN = /^[a-z0-9._]{1,30}$/;
export const NOT_PROFILE_PATHS: ReadonlySet<string> = new Set([
  'p',
  'reel',
  'reels',
  'stories',
  'explore',
  'tv',
  'accounts',
]);
export const PROMPT_MIN_LENGTH = 15;
export const DEFAULT_RESULT_COUNT = 25;
export const AGE_CEILING = 99;
export const CARD_REELS_VISIBLE = 3;
export const SHEET_REELS_VISIBLE = 4;
export const FIT_SCALE = 10;
export const ROUNDED_THOUSANDS_FROM = 1e5;
export const POSTING_DAILY_MAX_DAYS = 1.5;
/** The service takes at most this many creators per picks PATCH (`PICKS_BATCH_MAX`). */
export const PICKS_PATCH_MAX = 300;
export const RESULTS_PAGE = 12;
export const RUN_PICKER_MIN = 2;
export const RUN_PICKER_EDGE_GAP = 16;
export const LIVE_SKELETON_CARDS = ['first', 'second'] as const;
export const LIVE_CREATORS_SHOWN = 12;
export const SCORE_PART_MAX = 10;
export const CONSISTENCY_MIN_REELS = 3;
export const NEUTRAL_BOOST = 1;
export const METRIC_DECIMALS = 1;
export const MIN_BAR_PERCENT = 2;
export const ELAPSED_TICK_MS = 15_000;
